import { combineReducers } from "redux";

// import all reducers is here
import authReducers from './auth/index'
import studentReducers from "./student";
import currentPageRedcuer from './currentPage.reducer'

const createRootReducer = combineReducers({
    // router:connectRouter(history),
    authReducers,
    studentReducers,
    currentPageRedcuer

})

const rootReducers = (state, action) => {
    return createRootReducer(state, action);
}
export default rootReducers;